import { render, staticRenderFns } from "./App.vue?vue&type=template&id=28cdaaf9&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./App.vue?vue&type=style&index=0&id=28cdaaf9&prod&lang=scss&scoped=true"
import style1 from "./App.vue?vue&type=style&index=1&id=28cdaaf9&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cdaaf9",
  null
  
)

export default component.exports